import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowFitBottomRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2.75A.75.75 0 0 0 9.75 2H2v7.75h.75H2a.75.75 0 0 0 1.5 0h-.75.75V4.56l11.927 11.927a1 1 0 0 1-.175.013H6.75a.75.75 0 0 0 0 1.5h8.502A2.75 2.75 0 0 0 18 15.25v-8.5a.75.75 0 0 0-1.5 0v8.5q0 .09-.012.177L4.56 3.5h5.19a.75.75 0 0 0 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomRight20);
